module.exports = __webpack_public_path__ + "assets/img/appCode.cf81c989.png";